import React from "react";

export function LeftIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-slate-600">
      <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ArrowSmallIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M8 16l8-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M10 8h6v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

// Service icons
export function StarIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 2l2.6 6.6 7 .5-5.4 4.5 1.7 6.8L12 17.8 6.1 20.4l1.7-6.8L2.4 9.1l7-.5L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

export function PinIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 22s7-7.4 7-13a7 7 0 1 0-14 0c0 5.6 7 13 7 13Z" stroke="currentColor" strokeWidth="2" />
      <path d="M12 11a2.5 2.5 0 1 0-2.5-2.5A2.5 2.5 0 0 0 12 11Z" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function MonitorIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 5h16v11H4V5Z" stroke="currentColor" strokeWidth="2" />
      <path d="M8 19h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 16v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function MegaphoneIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 11v2c0 1.1.9 2 2 2h1l2 4h2l-2-4h2l8 3V6l-8 3H6c-1.1 0-2 .9-2 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M20 9v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function SparkIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 2l1.1 4.2L17 7.3l-3.9 1.1L12 12l-1.1-3.6L7 7.3l3.9-1.1L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M5 12l.7 2.4L8 15l-2.3.6L5 18l-.7-2.4L2 15l2.3-.6L5 12Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M19 12l.7 2.4L22 15l-2.3.6L19 18l-.7-2.4L16 15l2.3-.6L19 12Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

// Options icons
export function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M21 12.2c0 5-3.4 8.3-8.6 8.3A9.1 9.1 0 1 1 12.4 3c2.5 0 4.5.9 6.1 2.5l-2.5 2.4c-2.1-2-6.3-1.6-8.3 1a5.6 5.6 0 0 0 4.7 9c2.6 0 4.3-1.4 4.8-3.4h-4.8v-3.3H21Z" fill="currentColor" opacity="0.9" />
    </svg>
  );
}

export function BriefcaseIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M9 6V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1" stroke="currentColor" strokeWidth="2" />
      <path d="M4 8h16v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8Z" stroke="currentColor" strokeWidth="2" />
      <path d="M4 12h16" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function MapIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M9 18 3 21V6l6-3 6 3 6-3v15l-6 3-6-3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M9 3v15" stroke="currentColor" strokeWidth="2" />
      <path d="M15 6v15" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function PhoneBookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M7 3h12v18H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="2" />
      <path d="M9 7h8" stroke="currentColor" strokeWidth="2" />
      <path d="M9 11h8" stroke="currentColor" strokeWidth="2" />
      <path d="M9 15h8" stroke="currentColor" strokeWidth="2" />
      <path d="M7 3v18" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function DotsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M6 12h.01" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M12 12h.01" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M18 12h.01" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

export function StackIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 3 3 8l9 5 9-5-9-5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M3 12l9 5 9-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M3 16l9 5 9-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

export function HelpIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 21a9 9 0 1 0-9-9 9 9 0 0 0 9 9Z" stroke="currentColor" strokeWidth="2" />
      <path d="M9.5 9a2.8 2.8 0 0 1 5.2 1.4c0 1.9-2 2.1-2.7 3.2-.3.4-.3.7-.3 1.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 17h.01" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

// Appointment icons
export function CalendarIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M7 3v2M17 3v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M4 7h16" stroke="currentColor" strokeWidth="2" />
      <path d="M6 5h12a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function ClockIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10Z" stroke="currentColor" strokeWidth="2" />
      <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function TimerIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M9 2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 14l3-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 22a9 9 0 1 0-9-9 9 9 0 0 0 9 9Z" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
// add at bottom of icons.jsx
export function WebsiteIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 5h16v14H4V5Z" stroke="currentColor" strokeWidth="2" />
      <path d="M4 9h16" stroke="currentColor" strokeWidth="2" />
      <path d="M7 7h.01M10 7h.01" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

export function RefreshIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M21 12a9 9 0 1 1-2.6-6.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M21 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
